import React from "react";

const AboutUsInitialSection = () => {
  return (
    <section className="relative mb-12">
      <div className="flex flex-col md:p-4 md:min-h-screen">
        <div className="text-white flex-1 flex flex-col">
          <main className="md:flex-1 flex flex-col items-center p-1 pt-[16%] md:pt-[6%] mx-[6%] md:mx-[28%] z-10 pb-10 md:pb-[4%]">
            <h1 className="text-4xl md:text-7xl font-extrabold text-center text-white leading-[140%] tracking-[0] mb-6">
              AI Strategy, Crafted for Execution
            </h1>

            <p className="text-center text-lg md:text-xl font-medium leading-[140%] tracking-[0] md:mx-[14%] text-white">
              Bridging the gap between strategy and execution to deliver
              real-world AI impact.
            </p>
          </main>
          <div className="md:px-[8%]">
            <div
              className={`relative overflow-hidden text-white h-[288px] md:h-auto md:aspect-[4/2] min-w-full flex flex-row`}
            >
              <img
                src="/images/about-us-page/about-us-image-1.jpeg"
                alt="AI Strategy"
                className="w-full h-full object-scale-down md:object-cover absolute object-top scale-150 md:scale-100 grayscale opacity-80"
              />
              {/* Top Shadow */}
              <div className="absolute top-0 left-0 w-full h-12 md:h-32 bg-gradient-to-b from-app-background to-transparent z-10" />

              {/* Bottom Shadow */}
              <div className="absolute bottom-0 left-0 w-full h-32 bg-gradient-to-t from-app-background to-transparent z-10" />

              {/* Left Shadow */}
              <div className="hidden md:block absolute top-0 left-0 h-full w-32 bg-gradient-to-r from-app-background/90 to-transparent z-10" />

              {/* Right Shadow */}
              <div className="hidden md:block absolute top-0 right-0 h-full w-32 bg-gradient-to-l from-app-background/90 to-transparent z-10" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUsInitialSection;
